import { render, staticRenderFns } from "./orderDetailModal.vue?vue&type=template&id=87c9482c&scoped=true&"
import script from "./orderDetailModal.vue?vue&type=script&lang=js&"
export * from "./orderDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailModal.vue?vue&type=style&index=0&id=87c9482c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c9482c",
  null
  
)

export default component.exports